import React from 'react'
import PersonCard from '../components/PersonCard/PersonCard'

const Projects = () => {
    const user= 
        {
        name: "Advance Console Based Applications",
        linkdin: "https://www.youtube.com/@woixinstitute",
        works : "Console Based",
        details : "Created By Woix",       
        }
    const project2 =
        {
            name: "Woix Crypto World",
            linkdin: "https://woixcrypto.vercel.app/",
            works : "Crafting Your Crypto Success Story",
            details : "Created By Woix",       
            }
    return (
    <div>
        
        <PersonCard person={project2}/>
        <PersonCard person={user}/>
        
    </div>
  )
}

export default Projects